import { actions, getPublishersDatatableAsync } from './slices';

export const PublisherActions = {
  ...actions,
  getPublishersDatatableAsync,
};

export * from './thunkHandlers';
